import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromDocumentTypes from './doc-admin-reducer';

export const selectDocumentTypesState = createFeatureSelector<fromDocumentTypes.DocumentTypesState>(
    fromDocumentTypes.documentTypesFeatureKey
);

export const selectPermissions = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.permissions
);

export const selectRequirementPermissions = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.requirementPermissions
);

export const selectInitFacilityLookup = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.initFacilityLookup
);

export const selectFacilityLookups = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.facilityLookups
);

export const selectInitAssociationLookup = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.initAssociationLookup
);

export const selectAssociationLookups = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.associationLookups
);

export const candidateTaskTypes = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.candidateTaskTypes
);

export const selectPartnerNetworkTaskTypes = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.partnerNetworkTaskTypes
);

export const selectDocumentSummary = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.documentSummary
);

export const selectFilter = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.filter
);

export const selectDocumentTypeCategories = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state?.documentTypeCategories
);

export const selectDocumentTypeCategoriesList = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.documentTypeCategoriesList
);

export const selectSpecialtyLookups = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.specialityLookups
);

export const selectStateLookups = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.stateLookups
);

export const selectFacilityTypeLookups = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.facilityTypeLookups
);

export const selectManualReviewCandidateTypeSettingLookups = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.manualReviewCandidateTypeSettingLookups
);

export const selectWorkTypeSettingLookups = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.workTypeSettingLookups
);

export const selectLocumsContractTypeSettingLookups = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.locumsContractTypeSettingLookups
);

export const selectLinesOfBusinessLookups = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.linesOfBusinessLookups
);

export const selectCurrentDocument = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.currentDocument
);

export const selectDocumentsList = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.documentTypesList
);

export const selectDocumentType = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.documentType
);

export const selectRequirementLevelLookups = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.requirementLevelsLookups
);

export const selectOcrEnabledStatus = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.isOcrEnabled
);

export const selectToggleOcrSuccess = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.isOcrToggleSuccessful
);

export const selectIsSaving = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.isSaving
);

export const selectCurrentRedirectUrl = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.previousNavigationUrl
);

export const selectCurrentDocumentLevel = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.currentDocumentLevel
);

export const selectCurrentDocumentId = createSelector(
    selectDocumentTypesState,
    (state: fromDocumentTypes.DocumentTypesState) => state.currentDocumentId
);

export const selectDocDataAndLookups = createSelector(
    selectCurrentDocument,
    selectStateLookups,
    selectSpecialtyLookups,
    selectDocumentTypeCategories,
    candidateTaskTypes,
    selectRequirementLevelLookups,
    selectLinesOfBusinessLookups,
    (
        currentDocument,
        stateLookups,
        specialtyLookups,
        documentTypeCategories,
        candidateTaskTypes,
        requirementLevelLookups,
        linesOfBusinessLookups
    ) => {
        return {
            states: stateLookups,
            specialties: specialtyLookups,
            docTypeCategories: documentTypeCategories,
            candidateTaskTypes: candidateTaskTypes,
            document: currentDocument,
            requirementLevelLookups: requirementLevelLookups,
            linesOfBusinessLookups: linesOfBusinessLookups
        };
    }
);
